import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { showError } from "../../utils/toastUtils";
import Cookies from "js-cookie";
import AuthAPI from "../../api/admin/authApi";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/LanguageSwitcher";

function Login() {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [autoFilled, setAutoFilled] = useState(false);

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const savedEmail = Cookies.get("rememberEmail");
    const savedPassword = Cookies.get("rememberPassword");

    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRemember(true);
      setAutoFilled(true);
    }
  }, []);

  const validate = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email";
    }

    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password =
        "Password length must be equal or greater than 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      try {
        const res = await AuthAPI.login({ email, password });

        if (res.code === 200) {
          localStorage.setItem("admin_token", res.data.token);

          if (remember) {
            Cookies.set("rememberEmail", email);
            Cookies.set("rememberPassword", password);
          } else {
            Cookies.remove("rememberEmail");
            Cookies.remove("rememberPassword");
          }

          setTimeout(() => {
            window.location.href = "/admin/dashboard";
          }, 100);
        } else {
          showError(res.message);
        }
      } catch (err) {
        showError(err.response?.data?.message || "Login failed");
      }
    }
  };

  return (
    <div className="main-wrapper">
      <div className="overflow-hidden acc-vh">
        <div className="row vh-100 w-100 g-0">
          <div className="col-lg-6 vh-100 overflow-y-auto overflow-x-hidden">
            <div className="row">
              <div className="col-md-10 mx-auto">
                <form
                  method="post"
                  onSubmit={handleSubmit}
                  className="vh-100 d-flex justify-content-between flex-column p-4 pb-0"
                >
                  <div className="mt-2">
                    <LanguageSwitcher />
                  </div>
                  <div className="text-center auth-logo">
                    <Link to="/admin">
                      <img
                        src={`${process.env.PUBLIC_URL}/img/sansad-khel-mahotsav.webp`}
                        alt="logo"
                        style={{ width: 400, objectFit: "cover" }}
                      />
                    </Link>
                  </div>
                  <div>
                    <div className="mb-3">
                      <h3 className="mb-2">{t("login_title")}</h3>
                      <p className="mb-0">{t("login_subtitle")}</p>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">{t("email")}</label>
                      <div className="input-group input-group-flat">
                        <input
                          type="email"
                          className="form-control"
                          autoComplete="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder={t("email")}
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-mail" />
                        </span>
                      </div>
                      {errors.email && (
                        <span className="text-danger">{errors.email}</span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">{t("password")}</label>
                      <div className="input-group input-group-flat pass-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder={t("password")}
                          className={`form-control ${
                            autoFilled ? "autofilled" : ""
                          }`}
                          autoComplete="new-password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className={`ti toggle-password ${
                            showPassword ? "ti-eye" : "ti-eye-off"
                          } text-gray-9`}
                        />
                      </div>
                      {errors.password && (
                        <span className="text-danger">{errors.password}</span>
                      )}
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="form-check form-check-md d-flex align-items-center">
                        <input
                          className="form-check-input mt-0"
                          type="checkbox"
                          checked={remember}
                          onChange={(e) => setRemember(e.target.checked)}
                        />
                        <label
                          className="form-check-label text-dark ms-1"
                          htmlFor="checkebox-md"
                        >
                          {t("remember_me")}
                        </label>
                      </div>
                      <div className="text-end">
                        <Link
                          to="/admin/forgot-password"
                          className="link-danger fw-medium link-hover"
                        >
                          {t("forgot_password")}
                        </Link>
                      </div>
                    </div>
                    <div className="mb-3">
                      <button type="submit" className="btn btn-primary w-100">
                        {t("login")}
                      </button>
                    </div>
                    <div className="mb-3">
                      <p className="mb-0">
                        {t("not_registered")}
                        <Link
                          to="/admin/register"
                          className="link-indigo fw-bold link-hover ms-1"
                        >
                          {t("register_mp")}
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="text-center pb-4">
                    <p className="text-dark mb-0">
                      Copyright © - Axepert Exhibits Pvt. Ltd.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-lg-6 account-bg-01" />
        </div>
      </div>
    </div>
  );
}

export default Login;
